import { getAuthToken } from "../security/AuthLogin";

const BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
const API_URL = `${BASE_URL}/api`;

export interface CpvFlat {
  cod_cpv: string;
  cpv: string;
  cod_clasificacion: string | null;
}

let cache: Promise<CpvFlat[]> | null = null;

export const fetchCpvTree = (): Promise<CpvFlat[]> => {
  if (cache) return cache;

  const token = getAuthToken();
  if (!token) {
    window.location.href = "/login";
    return Promise.reject(new Error("Token no encontrado"));
  }

  cache = fetch(`${API_URL}/cod_cpv/tree`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(async (response) => {
      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem("authToken");
          window.location.href = "/login";
        }
        const text = await response.text();
        throw new Error(`Error al obtener el árbol CPV: ${text}`);
      }
      const json = await response.json();
      return json.data as CpvFlat[];
    })
    .catch((err) => {
      cache = null;
      throw err;
    });

  return cache;
};

export const clearCpvTreeCache = () => {
  cache = null;
};
